import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import AdminLogin from "@/admin/AdminLogin";
import { AdminLayout } from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import PagesManager from "@/admin/PagesManager";
import PlatformsManager from "@/admin/PlatformsManager";
import SocialMediaManager from "@/admin/SocialMediaManager";
import { CoachesManager, StaffManager, AgeGroupsManager, SponsorsManager, TestimonialsManager } from "@/admin/resourceConfigs";
import NewsManager from "@/admin/NewsManager";
import GalleryManager from "@/admin/GalleryManager";
import EnquiriesManager from "@/admin/EnquiriesManager";
import SettingsManager from "@/admin/SettingsManager";
import UsersManager from "@/admin/UsersManager";
import Migration from "@/admin/Migration";
import ForceChangePassword from "@/admin/ForceChangePassword";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#0C131F]"><Loader2 className="h-8 w-8 animate-spin text-[#E8A317]" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.must_change_password) return <ForceChangePassword />;
  return <AdminLayout>{children}</AdminLayout>;
};

export default function AdminApp() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/pages" element={<Protected><PagesManager /></Protected>} />
      <Route path="/platforms" element={<Protected><PlatformsManager /></Protected>} />
      <Route path="/social-media" element={<Protected><SocialMediaManager /></Protected>} />
      <Route path="/coaches" element={<Protected><CoachesManager /></Protected>} />
      <Route path="/staff" element={<Protected><StaffManager /></Protected>} />
      <Route path="/age-groups" element={<Protected><AgeGroupsManager /></Protected>} />
      <Route path="/sponsors" element={<Protected><SponsorsManager /></Protected>} />
      <Route path="/gallery" element={<Protected><GalleryManager /></Protected>} />
      <Route path="/news" element={<Protected><NewsManager /></Protected>} />
      <Route path="/testimonials" element={<Protected><TestimonialsManager /></Protected>} />
      <Route path="/enquiries" element={<Protected><EnquiriesManager /></Protected>} />
      <Route path="/settings" element={<Protected><SettingsManager /></Protected>} />
      <Route path="/migration" element={<Protected><Migration /></Protected>} />
      <Route path="/users" element={<Protected><UsersManager /></Protected>} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
